import { render, staticRenderFns } from "./ConfectionModal.vue?vue&type=template&id=cd461940&"
import script from "./ConfectionModal.vue?vue&type=script&lang=js&"
export * from "./ConfectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports